import {createContext} from 'react';
import type {PreparedPitchAudio} from './pitch-audio-plan';
export const PitchAudioContext=createContext<readonly PreparedPitchAudio[]>([]);
